(() => {
  'use strict';
  if (window.vessariqCardPricesReady) return;
  window.vessariqCardPricesReady = true;
  const selector = '[data-vq-card-price]';
  function render() {
    let config;
    try { config = JSON.parse(document.getElementById('vq-wholesale-config').textContent); }
    catch { return; }
    const tiers = (config.tiers || []).filter(t => Number.isSafeInteger(t.minimumQuantity) && t.minimumQuantity > 0 && Number.isFinite(t.discountPercent) && t.discountPercent > 0 && t.discountPercent < 100)
      .sort((a, b) => a.minimumQuantity - b.minimumQuantity);
    const eligible = new Set((config.nativeCheckout?.eligibleProductIds || []).map(String));
    document.querySelectorAll(selector).forEach(card => {
      const price = Number(card.dataset.retailCents);
      const mode = document.documentElement.dataset.purchaseMode || card.dataset.savedMode;
      const showWholesale = config.approved === true && config.showPurchaseMode === true && config.nativeCheckout?.enabled === true && tiers.length > 0 && mode === 'wholesale'
        && eligible.has(card.dataset.productId) && card.dataset.giftCard !== 'true'
        && !(config.excludeProductHandles || []).includes(card.dataset.handle)
        && card.dataset.currency === config.currency && Number.isSafeInteger(price) && price >= 0;
      card.querySelector('[data-card-retail]').hidden = showWholesale;
      card.querySelector('[data-card-wholesale]').hidden = !showWholesale;
      if (!showWholesale) return;
      const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: config.currency });
      card.querySelector('[data-card-wholesale-tiers]').replaceChildren(...tiers.map((tier, index) => {
        const row = document.createElement('span');
        row.className = 'vq-card-price__tier';
        const label = document.createElement('span');
        const next = tiers[index + 1];
        const range = next ? `${tier.minimumQuantity}–${next.minimumQuantity - 1}` : `${tier.minimumQuantity}+`;
        label.textContent = `${range} pieces · ${tier.discountPercent}% off`;
        const amount = document.createElement('strong');
        amount.textContent = `From ${money.format((price - Math.round(price * tier.discountPercent / 100)) / 100)}`;
        row.append(label, amount);
        return row;
      }));
    });
  }
  document.addEventListener('vq:purchase-mode', render);
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('pageshow', render);
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) render();
  }).observe(main, { childList: true, subtree: true });
  render();
})();
